module.exports = __webpack_public_path__ + "img/selected3-min.2eb64f9e.png";